import React from 'react';

import { useGetUserRolesQuery } from 'services/userRolesService';
import ErrorLayout from 'components/ErrorLayout';
import Loader from 'components/Loader';

function WithUserRoles({ children }) {
  const { error, data } = useGetUserRolesQuery();

  if (data) {
    return children;
  } else if (error) {
    return (
      <ErrorLayout
        title="You are not authorised to view this page!"
        message={error.message}
      />
    );
  } else {
    return <Loader />;
  }
}

export default WithUserRoles;
